var mentions_default = {
  "mentionPalette": "MKg-C",
  "mention": "_2rgpU",
  "mentionViewer": "XOOkd",
  "mentionSuggestionsEntry": "eZ2Xs",
  "mentionSuggestionsEntryFocused": "u4-bQ",
  "mentionSuggestionsEntryText": "vmkZ4",
  "mentionSuggestionsEntryAvatar": "_2bAk8",
  "mentionSuggestions": "cF2Jd",
  "cursorDefault": "SVcWZ",
  "cursorPointer": "_1zTX1"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
